module.exports = __webpack_public_path__ + "img/doc.9d1e132a.png";